/** Save handling shared by a record page's in-place editors (an item's, a commitment's). */
import { useState } from 'react';

/** Runs a save; an error message (string) or a throw keeps the editor open with the reason. */
export function useEditorSave(onSave: () => Promise<string | null | void>, close: () => void) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const run = async () => {
    setSaving(true);
    setError(null);
    try {
      const result = await onSave();
      if (typeof result === 'string' && result) {
        setError(result);
        return;
      }
      close();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'The change could not be saved.');
    } finally {
      setSaving(false);
    }
  };
  return { saving, error, run };
}
